import { useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import axiosClient from '../api/interceptor-v2';

//fetch user list

const fetchUserList = async ({ queryKey  }) => {
  
  const [_key, searchName] = queryKey;
  
  try {

    const response = await axiosClient.get(
      `/users${
        searchName ? `?searchName=${encodeURIComponent(searchName)}` : ""
      }`
    );
    let data = response.data.result;
    return data;

  }
  catch (err) {

    console.error('fetchData error:', err.message);
    throw err;

  }

};

//fetch user roles list

const fetchUserRoles = async () => {

  try {

    const response = await axiosClient.get(`/user_roles`)
    let data = response.data.result;
    return data;

  }
  catch (err) {

    console.error('fetchData error:', err.message);
    throw err;

  }

};

//fetch edit user data

const fetchEditUserData = async ({ queryKey }) => {

  try {

      const [_key, userId] = queryKey;

      console.log('fetchData inside---', {queryKey});

          if (!userId) return;

          console.log('region inside', userId)

          // Await the axios call to ensure you receive the response before proceeding
          const response = await axiosClient.get(`/users?userId=${userId}`)
          let data = response.data.result;
          console.log('fetch response file xx', data)
          return data;

    } catch (err) {

        console.error('fetchData error:', err.message);
        throw err;

    }
  
};

export function useUserList(searchName) {
  return useQuery({
    queryKey: ['getUserListData', searchName],
    queryFn: fetchUserList,
    cacheTime: 60 * 60 * 1000,
  });
}

export function useUserRoles() {
    return useQuery({
        queryKey: ['getUserRolesData'],
        queryFn: fetchUserRoles,
        cacheTime: 60 * 60 * 1000, 
    });
}

export function useUserEdit(userId) {
  //alert('editId', editId)
  return useQuery({
      queryKey: ['editUserData', userId],
      queryFn: fetchEditUserData,
      cacheTime: 60 * 60 * 1000, 
      enabled: !!userId,
  });
}


//add user

export const useUserAddMutation = (
  onSuccessCallback
) => {
  
  const queryClient = useQueryClient()

  return useMutation({
    // The function that actually performs the POST
    mutationKey: ['addUser'],
    mutationFn: async (data) => {

      // Perform the POST request
      const res = await axiosClient.post(`/users`, data)
      return res.data
    },

    // Handle what to do after success
    onSuccess: (data) => {
      const { result, error } = data

      // refetch other queries if needed
      queryClient.invalidateQueries(["getUserListData"])

      // Or trigger a callback
      if (onSuccessCallback) onSuccessCallback(data.result)

    },

    // Handle errors
    onError: (error) => {
      console.error("POST Mutation Error:", error)
    },
  })

}

//update user

export const useUserUpdateMutation = (
  userId,

  onSuccessCallback
) => {
  
  const queryClient = useQueryClient()

  return useMutation({
    // The function that actually performs the POST
    mutationKey: ['updateUser'],
    mutationFn: async (data) => {

      const payload = {...data, ...{'id': userId}}

      // Perform the POST request
      const res = await axiosClient.put(`/users`, payload)
      return res.data
    },

    // Handle what to do after success
    onSuccess: (data) => {
      const { result, error } = data

      // refetch other queries if needed
      queryClient.invalidateQueries(["getUserListData"])

      // Or trigger a callback
      if (onSuccessCallback) onSuccessCallback(data.result)

    },

    // Handle errors
    onError: (error) => {
      console.error("POST Mutation Error:", error)
    },
  })

}

//delete user 

export const useDeleteUserMutation = (
  userId,
  onSuccessCallback
) => {
  const queryClient = useQueryClient()

  return useMutation({
    // The function that actually performs the POST
    mutationKey: ['deleteUser'],
    mutationFn: async () => {

      console.log('del id*****', userId)

      const payload = {
        userId:userId
      }

      // Perform the POST request
      const res = await axiosClient.delete(`/users`, {data: payload})
      return res.data
    },

    // Handle what to do after success
    onSuccess: (data) => {
      const { result, error } = data

      // refetch other queries if needed
      queryClient.invalidateQueries(["getUserListData"])

      // Or trigger a callback
      if (onSuccessCallback) onSuccessCallback(data.result)

    },

    // Handle errors
    onError: (error) => {
      console.error("POST Mutation Error:", error)
    },
  })

}